<template>
<!--    <b-row>-->
<!--        <b-col cols="9" class="mx-auto">-->
<!--            <b-card header="Eligibility Checklist">-->
<!--                <p class="mb-5">In order to confirm your eligibility for this application, please provide answers to the following checklist questions. It is imperative that you answer these questions truthfully in order to improve your chances of application success. Failing to answer these questions truthfully may result in the unnecessary loss of service or application fees.</p>-->
<!--                <table class="table">-->
<!--                    <thead>-->
<!--                        <tr>-->
<!--                            <th style="width: 150px">-->
<!--                                <span class="d-inline-block" style="margin-right: 35px">Yes</span>-->
<!--                                <span>No</span>-->
<!--                            </th>-->
<!--                            <th>Question</th>-->
<!--                        </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                        <tr v-if="isFetching">-->
<!--                            <td colspan="2">-->
<!--                                <em>Fetching eligibility checklist...</em>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr v-for="(item, index) in eligibilities" :key="item.id">-->
<!--                            <td>-->
<!--                                <b-form-radio-group class="checklist" v-model="eligibilities[index].is_eligible" :options="options" buttons @change="error = {}"></b-form-radio-group></td>-->
<!--                            <td>{{ item.name }}</td>-->
<!--                        </tr>-->
<!--                    </tbody>-->
<!--                </table>-->
<!--                <template slot="footer">-->
<!--                    <b-alert show v-if="error.message" variant="danger" class="d-inline-block">{{ error.message }}</b-alert>-->
<!--                    <b-button class="float-right" variant="primary" @click.prevent="onSubmit" :disabled="isLoading">{{ isLoading ? 'Saving...' : 'Continue' }} <font-awesome-icon icon="arrow-alt-circle-right" /> </b-button>-->
<!--                </template>-->
<!--            </b-card>-->
<!--        </b-col>-->
<!--    </b-row>-->
  <div>
    <div class="bg-gray-100 dark:bg-darkPrimary mb-4 rounded-md relative pt-4 lg:pt-0 overflow-y-auto overflow-x-hidden" v-if="!needHelpButton.isClicked">
      <Header class="mt-6" />
      <div class="bg-white dark:bg-coolGray-800 rounded-lg p-4 mb-20 overflow-x-auto flex-1 max-w-5xl mx-auto">
        <div>
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="width: 84%">
            {{feeAgreement.project.visa.name}}
          </div>
        </div>
        <div class="grid grid-cols-2 break-words" v-for="(item, index) in eligibilities" :key="item.id" style="background-color: rgba(247, 247, 247, var(--tw-bg-opacity));">
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="width: 84%">
            {{ item.name }}
          </div>
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="word-wrap: initial;">
            <label class="radio mb-2 pr-4">
              <input
                  type="radio"
                  class="radio__input mr-2"
                  :name="'eligibility-radio-'+index"
                  :value="1"
                  v-model="eligibilities[index].is_eligible"
                  @change="error = {}"
              /> Yes
            </label>
            <label class="radio mb-2 pr-4">
              <input type="radio" class="radio__input mr-2" :name="'eligibility-radio-'+index" v-model="eligibilities[index].is_eligible" @change="error = {}" :value="0"/> No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-4" v-else>
      <div class="col-span-12 md:col-span-9 bg-gray-100 dark:bg-darkPrimary mb-4 rounded-md relative pt-4 lg:pt-0 overflow-y-auto overflow-x-hidden">
        <Header class="mt-6" />
        <div class="bg-white dark:bg-coolGray-800 rounded-lg p-4 mb-20 overflow-x-auto flex-1 max-w-5xl mx-auto">
        <div>
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="width: 84%">
            {{feeAgreement.project.visa.name}}
          </div>
        </div>
        <div class="grid grid-cols-2 break-words" v-for="(item, index) in eligibilities" :key="item.id" style="background-color: rgba(247, 247, 247, var(--tw-bg-opacity));">
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="width: 84%">
            {{ item.name }}
          </div>
          <div class="col-span-8 px-6 py-3 text-left text-sm text-black font-semibold tracking-wider dark:text-darkTextLight" style="word-wrap: initial;">
            <label class="radio mb-2 pr-4">
              <input
                  type="radio"
                  class="radio__input mr-2"
                  :name="'eligibility-radio-'+index"
                  :value="1"
                  v-model="eligibilities[index].is_eligible"
                  @change="error = {}"
              /> Yes
            </label>
            <label class="radio mb-2 pr-4">
              <input type="radio" class="radio__input" :name="'eligibility-radio-'+index" v-model="eligibilities[index].is_eligible" @change="error = {}" :value="0"/> No
            </label>
          </div>
        </div>
      </div>
      </div>
      <NeedHelp />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import _forEach from 'lodash/forEach'
import _find from 'lodash/find'
import Header from "./eligibility/Header";
import NeedHelp from "./NeedHelp";
import {mapActions, mapGetters} from 'vuex';
export default {
    name: 'eligibility',
  components: {NeedHelp, Header},
  data() {
        return {
            eligibilities: [],
            isLoading: false,
            isFetching: false,
            options: [
                { text: 'Yes', value: 1 },
                { text: 'No', value: 0 },
            ],
            error: {}
        }
    },
    methods: {
      ...mapActions('client',['setEligibility', 'setContinueButton', 'setNeedHelpButton', 'setShowFooter']),
        beforeCreate() {
            if (this.isEligible) {
                this.$router.push('/not-eligible');
            }
        },
        async onSubmit() {
            this.error = {};

            if (this.notReady) {
                this.error.message = "Please answer all the eligibility questions before proceeding."
                return false;
            }

            this.isLoading = true;

            return this.$http.post(this.app.version + "/front/agreement/eligibilities", { visa_eligibilities: this.eligibilities }).then(async response => {
                

                this.isLoading = false;
                
                let isEligible = await !_find(this.eligibilities, o => { return !o.is_eligible })
                let routerLink = isEligible ? "/agreement" : "/not-eligible";
                this.setEligibility(isEligible);
                this.$router.push(routerLink)
            }).catch(error => {
                swal({
                    title: 'Error',
                    icon: 'error',
                    text: error.response.data.message
                })
                this.isLoading = false;
            }).finally(() => {
              this.setContinueButton({isClicked: false, isEnabled: true,text: 'Continue'});
              this.setNeedHelpButton({isClicked: false, isEnabled: true});
            })
        },
        fetchEligibility() {
            this.isFetching = true;
            return this.$http.get(this.app.version + "/front/agreement/visa-eligibilities").then(response => {
                let eligibilities = [];
                _forEach(response.data.eligibilities, o => {
                    eligibilities.push({
                        id: o.id,
                        name: o.name,
                        is_eligible: null
                    })
                })
                this.eligibilities = eligibilities
                this.isFetching = false
            }).catch(error => {
                swal({
                    title: 'Error',
                    icon: 'error',
                    text: error.response.data.message
                })
                this.isFetching = false
            })
        }
    },
    mounted() {
        this.fetchEligibility();
        this.setShowFooter(true);
      this.setNeedHelpButton({isClicked: false});
      this.setContinueButton({isClicked: false, text: 'Continue'});
    },
  watch: {
    continueButton: function (val){
      if(val.isClicked){
        this. onSubmit();
      }
    },
    eligibilities: {
      handler: function(val) {
        if(!this.notReady){
          this.setContinueButton({isEnabled: true});
        }else{
          this.setContinueButton({isEnabled: false});
        }
      },
      deep: true
    }
  },
    computed: {
      ...mapGetters({
        continueButton: 'client/continueButton',
        feeAgreement: 'client/feeAgreement',
        needHelpButton: 'client/needHelpButton',
        isEligible: 'client/isEligible'
      }),
        notReady() {
            return _find(this.eligibilities, o => { return o.is_eligible == null }) ? true : false
        }
    }
}
</script>
<style scoped>
    .table td, .table th {
        padding: 12px 0;
        font-size: 14px;
    }
    .table th {
        color: #2A1EAA;
        font-weight: 600;
    }
</style>